import { Component } from '@angular/core';

@Component({
  selector: 'app-vinavon-button',
  templateUrl: './vinavon-button.component.html',
  styleUrls: ['./vinavon-button.component.scss']
})
export class VinavonButtonComponent {

}
